import { useMutation } from "@tanstack/react-query";
import {
  postSsoAuthorizationRequestsPublicIDApprove,
  postSsoAuthorizationRequestsPublicIDDeny,
  type SsoAuthorizationDecisionResult,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Decision = {
  publicID: string;
  isApproved: boolean;
};

type Props = {
  onSuccess?: (result: SsoAuthorizationDecisionResult) => void;
  onError?: (error: unknown) => void;
};

// Either answer ends on the backend's resume URL; the browser has to be sent there, not the query client.
export const useDecideSsoAuthorizationRequestMutation = ({
  onSuccess,
  onError,
}: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ publicID, isApproved }: Decision) =>
        isApproved
          ? postSsoAuthorizationRequestsPublicIDApprove(publicID)
          : postSsoAuthorizationRequestsPublicIDDeny(publicID),
    ),
    onSuccess,
    onError,
  });
